import { useMemo } from 'react';
import { formatAvgPoints } from '../utils';
import type { Player } from '../components/PlayerFiltersView/PlayerFiltersView';
import type { ProfileSummaryItem } from '../modals/PlayerCardModal/PlayerCardModal';

export const usePlayerProfileSummary = (
  profilePlayer: Player | undefined
): ProfileSummaryItem[] => {
  return useMemo(() => {
    if (!profilePlayer) {
      return [];
    }

    const matchdayPoints = profilePlayer.matchdayPoints ?? profilePlayer.gameweekPoints ?? 0;

    return [
      { label: 'GW Pts', value: `${matchdayPoints}` },
      { label: 'Avg. Pts', value: formatAvgPoints(profilePlayer.averagePoints) },
      { label: 'Selected', value: `${profilePlayer.percentSelected}%` },
      { label: 'Bonus Pts', value: `${profilePlayer.bonusPoints}` },
      { label: 'Total Pts', value: `${profilePlayer.totalPoints}` },
    ];
  }, [profilePlayer]);
};
